"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/** It will fit iframe inside flow player */
const IframeResizer = props => {
  const aspectRatio = props.aspectRatio,
        minHeight = props.minHeight,
        children = props.children;

  const _useState = (0, _react.useState)(-1),
        _useState2 = _slicedToArray(_useState, 2),
        height = _useState2[0],
        setHeight = _useState2[1];

  const wrapper = (0, _react.useRef)();
  const adjustVideoWidth = (0, _react.useCallback)((0, _debounce2.default)(() => {
    const bottomBar = document.getElementById('cccisd-flow-bottom-bar');

    if (!wrapper || !wrapper.current || !bottomBar) {
      setHeight(0);
      return;
    } // Check if we are inside player with sticky bottom bar


    let hasStickyBar = false;
    let parent = wrapper.current.parentNode;

    while (parent && parent !== document) {
      if (parent.attributes['data-cccisd-sticky-bottom-bar']) {
        hasStickyBar = true;
        break;
      }

      parent = parent.parentNode;
    }

    if (!hasStickyBar) {
      setHeight(0);
      return;
    }

    const wrapperRect = wrapper.current.getBoundingClientRect();
    const barRect = bottomBar.getBoundingClientRect();
    const barStyles = window.getComputedStyle(bottomBar);
    let calculatedHeight = barRect.top - wrapperRect.top - parseInt(barStyles.marginTop, 10) - 1; // -1 just to avoid rounding issues

    if (calculatedHeight * aspectRatio >= wrapperRect.width) {
      setHeight(0);
    } else {
      setHeight(Math.max(calculatedHeight, minHeight));
    }
  }, 500), []);
  (0, _react.useEffect)(() => {
    window.addEventListener('resize', adjustVideoWidth);
    return () => {
      window.removeEventListener('resize', adjustVideoWidth);
    };
  }, []);
  (0, _react.useEffect)(() => {
    adjustVideoWidth();
  }, [aspectRatio, minHeight]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: wrapper
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _style.default.wrapper,
    style: _objectSpread(_objectSpread({}, height >= 0 && {
      paddingBottom: height === 0 ? `${100 / aspectRatio}%` : `${height}px`
    }), height > 0 && {
      maxWidth: `${height * aspectRatio}px`
    })
  }, height >= 0 ? children : null));
};

IframeResizer.propTypes = {
  aspectRatio: _propTypes.default.number,
  minHeight: _propTypes.default.number,
  children: _propTypes.default.node
};
IframeResizer.defaultProps = {
  aspectRatio: 16 / 9,
  minHeight: 100
};
var _default = IframeResizer;
exports.default = _default;